import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { OrderDiscountCode } from '../interfaces/order-discount-code';

@Injectable({ providedIn: 'root' })
export class PricingService {
  public url = '/api/pricing';

  constructor(public http: HttpClient) {}

  public getDiscountLookup(): Promise<any[]> {
    return this.http
      .get(`${this.url}/discountLookup`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public updateDiscountLookup(lookup): Promise<any[]> {
    console.log('Saving lookup to: ', lookup);

    return this.http
      .put(`${this.url}/updateLookup`, lookup)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public getLongDistanceTimeBands(): Promise<any[]> {
    return this.http
      .get(`${this.url}/longDistanceTimeBands`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public updateLongDistanceTimeBand(timeBand): Promise<any[]> {
    return this.http
      .put(`${this.url}/updateLongDistanceTimeBand`, timeBand)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public deleteLongDistanceTimeBand(timeBand): Promise<any> {
    return this.http.post(`${this.url}` + '/deleteLongDistanceTimeBand', timeBand).toPromise();
  }

  public addLongDistanceTimeBand(timeBand): Promise<any> {
    return this.http.post(`${this.url}` + '/addLongDistanceTimeBand', timeBand).toPromise();
  }

  public extractData(res) {
    return res;
  }

  public handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }
}
